import type { MouseEvent } from "react";
import { ToastAction } from "@/components/ui/toast";
import { toast } from "@/hooks/use-toast";
import { abreNoAppDoWhatsApp, linkDoAppPeloDaWeb, vaiPeloAppDoWhatsApp } from "@/lib/whatsappApp";

// Todo botão do painel que abre uma conversa do WhatsApp passa por aqui (ver lib/whatsappApp): no aplicativo do
// computador quando este computador o escolheu, senão a aba de hoje, igual. Sem o aplicativo, o aviso oferece o
// navegador.
export function abreWhatsApp(linkWeb: string) {
  const app = linkDoAppPeloDaWeb(linkWeb);
  if (app && vaiPeloAppDoWhatsApp()) {
    abreNoAppDoWhatsApp(app, () =>
      toast({
        title: "O WhatsApp não abriu neste computador",
        description: "Se ele não tem o aplicativo, desmarque «Abrir no aplicativo do WhatsApp» ao mudar o status de um pedido.",
        action: (
          <ToastAction altText="Abrir no navegador" onClick={() => window.open(linkWeb, "_blank")}>
            Abrir no navegador
          </ToastAction>
        ),
      }),
    );
    return;
  }
  window.open(linkWeb, "_blank");
}

/** Para os links `<a href target="_blank">` do WhatsApp: com o aplicativo escolhido, ele no lugar da aba. */
export function cliqueNoLinkDoWhatsApp(e: MouseEvent<HTMLAnchorElement>) {
  const linkWeb = e.currentTarget.getAttribute("href") || "";
  if (!vaiPeloAppDoWhatsApp() || !linkDoAppPeloDaWeb(linkWeb)) return;
  e.preventDefault();
  abreWhatsApp(linkWeb);
}
